import type {
  ConsentListener,
  ConsentProvider,
  ConsentSnapshot,
} from '@/Integrations/Consent/types';

function createSnapshot(overrides: Partial<ConsentSnapshot> = {}): ConsentSnapshot {
  return {
    functional: true,
    analytics: false,
    marketing: false,
    source: 'default',
    updatedAt: Date.now(),
    ...overrides,
  };
}

export function createStaticConsentProvider(
  initial: Partial<ConsentSnapshot> = {},
): ConsentProvider {
  const listeners = new Set<ConsentListener>();
  const snapshot = createSnapshot(initial);

  return {
    name: 'static',
    async init() {
      listeners.forEach((listener) => listener(snapshot));
    },
    getSnapshot() {
      return snapshot;
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
